import { textMarshal } from "text-marshal";

class IntlTelInputElement {
  constructor(element) {
    this.sourceInputElement = element;
    this.template = '';
    this.config = { attributes: true, childList: false, subtree: false};
    this.intlInputElement = intlTelInput(this.sourceInputElement, {
      autoPlaceholder: 'aggressive',
      initialCountry: element.getAttribute('data-country-code') || 'fr',
      nationalMode: false,
      separateDialCode: true,
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.0.2/js/utils.js'
    });

    this.events();
    return this.intlInputElement;
  }

  events () {
    this.sourceInputElement.addEventListener('countrychange', () => {
      this.sourceInputElement.value = '';
      this.updateTemplate();
    });

    this.sourceInputElement.addEventListener('input', (e) => {
      let inputValue = e.target.value;

      // If the number starts with a "0", remove it for validation but keep it for display
      if (inputValue.startsWith('0')) {
        inputValue = inputValue.substring(1);
      }

      const mask = textMarshal({
        input: inputValue,
        template: this.template,
        disallowCharacters: [/[a-z]/],
      });
      // Add back the leading "0" if it was initially present
      this.sourceInputElement.value = (e.target.value.startsWith('0') ? '0' : '') + mask.marshaltext;
    });

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          if (mutation.attributeName === 'placeholder') {
            this.updateTemplate();
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(this.sourceInputElement, this.config);
  }

  updateTemplate() {
    if (this.sourceInputElement.hasAttribute('placeholder')) {
      this.template = this.sourceInputElement.getAttribute("placeholder").replace(/[0-9]/g, "X");
    }
  }
}

const telInputs = document.querySelectorAll('input[type="tel"]');
console.debug('[intl-tel-input] Found tel inputs:', telInputs.length, telInputs);

telInputs.forEach((input) => {
  input.intlTelInput = new IntlTelInputElement(input);
})
